/* MAMEIDO Produktseite: Garantie-Box und Seitenfenster fuer "Fragen und Antworten" / "Bewertungen".
   Markup: snippets/mameido-guarantee.liquid und snippets/mameido-info-rows.liquid
   Styles: assets/mameido-info-panels.css */
(function () {
  'use strict';

  /* ---------- Garantie-Box ---------- */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-mgb-toggle]');
    if (!toggle) return;
    var box = toggle.closest('[data-mgb]');
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  });

  /* ---------- Seitenfenster ---------- */

  var rows = document.querySelector('[data-mip-rows]');
  var panel = document.querySelector('[data-mip]');
  var overlay = document.querySelector('[data-mip-overlay]');
  if (!rows || !panel || !overlay) return;

  // Fenster und Milchglas direkt unter <body>, damit kein Elternelement das fixed-Layout verschiebt.
  document.body.appendChild(overlay);
  document.body.appendChild(panel);

  var titleEl = panel.querySelector('[data-mip-title]');
  var bodyEl = panel.querySelector('[data-mip-body]');
  var closeBtn = panel.querySelector('[data-mip-close]');
  var root = document.documentElement;

  function sections() {
    return Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-"]'));
  }

  // Die vorhandene FAQ: Abschnitt mit den aufklappbaren Fragen.
  function findFaq() {
    return sections().filter(function (s) {
      return s.querySelector('[id^="FAQ-content-"]');
    })[0] || null;
  }

  // Das vorhandene Judge.me-Bewertungs-Widget (nicht das kleine Sterne-Badge im Produktkopf).
  function findReviews() {
    return sections().filter(function (s) {
      return s.querySelector('.jdgm-review-widget, .jdgm-rev-widg, #judgeme_product_reviews');
    })[0] || null;
  }

  var SOURCES = {
    faq: { title: 'Fragen und Antworten', find: findFaq },
    reviews: { title: 'Bewertungen', find: findReviews },
    // Seite, die beim Öffnen geladen wird (Link "Versand" unter dem Preis)
    shipping: { title: 'Zahlung und Versand', url: '/pages/payment-shipping', remote: true }
  };

  // Zeilen ohne passenden Inhalt auf dieser Seite ausblenden.
  var visibleRows = 0;
  Array.prototype.forEach.call(rows.querySelectorAll('[data-mip-open]'), function (button) {
    var source = SOURCES[button.dataset.mipOpen];
    var available = !!(source && !source.remote && source.find());
    button.hidden = !available;
    if (available) visibleRows++;
  });
  // Ohne passenden Inhalt bleiben die Zeilen weg, das Fenster selbst steht trotzdem für den Link "Versand" bereit.
  if (!visibleRows) rows.hidden = true;

  var moved = null;
  var returnTimer = null;
  var lastTrigger = null;

  function moveIn(section) {
    var nodes = Array.prototype.slice.call(section.childNodes);
    var holder = document.createElement('div');
    holder.className = 'mip__content';
    nodes.forEach(function (node) { holder.appendChild(node); });
    bodyEl.appendChild(holder);
    moved = { section: section, nodes: nodes, holder: holder };
  }

  function moveOut() {
    window.clearTimeout(returnTimer);
    Array.prototype.forEach.call(bodyEl.querySelectorAll('.mip__content--page'), function (node) {
      node.parentNode.removeChild(node);
    });
    if (!moved) return;
    moved.nodes.forEach(function (node) { moved.section.appendChild(node); });
    if (moved.holder.parentNode) moved.holder.parentNode.removeChild(moved.holder);
    moved = null;
  }

  function isOpen() {
    return panel.classList.contains('is-open');
  }

  var remoteCache = {};

  function loadRemote(source) {
    if (remoteCache[source.url]) return Promise.resolve(remoteCache[source.url]);
    return fetch(source.url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('http');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('#MainContent .rte') || doc.querySelector('#MainContent');
        if (!content) throw new Error('empty');
        Array.prototype.forEach.call(content.querySelectorAll('h1, script, style, .mcrumb'), function (node) {
          node.parentNode.removeChild(node);
        });
        Array.prototype.forEach.call(content.querySelectorAll('table'), function (table) {
          [].forEach.call(table.querySelectorAll('td, th'), function (cell) {
            // Leerzeilen (<br>) am Zellende und ein führendes &nbsp; entfernen
            [].slice.call(cell.querySelectorAll('br')).forEach(function (br) {
              var node = br, trailing = true;
              while (trailing && node && node !== cell) {
                for (var s = node.nextSibling; s; s = s.nextSibling) {
                  if ((s.nodeType === 1 && s.nodeName !== 'BR') || (s.nodeType === 3 && s.textContent.trim())) { trailing = false; break; }
                }
                node = node.parentNode;
              }
              if (trailing) br.parentNode.removeChild(br);
            });
            if (cell.firstChild && cell.firstChild.nodeType === 3) cell.firstChild.textContent = cell.firstChild.textContent.replace(/^[\s\u00a0]+/, '');
          });
          var rows = table.rows;
          if (!rows.length) return;
          var labels = Array.prototype.map.call(rows[0].cells, function (cell) {
            return cell.textContent.replace(/\u00a0/g, ' ').trim();
          });
          Array.prototype.forEach.call(rows, function (row, i) {
            if (i === 0) { row.classList.add('mpt-head'); return; }
            Array.prototype.forEach.call(row.cells, function (cell, j) { cell.setAttribute('data-label', labels[j] || ''); });
          });
          table.classList.add('mpt-table');
        });
        remoteCache[source.url] = content.innerHTML;
        return remoteCache[source.url];
      });
  }

  function show(trigger) {
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    root.classList.add('mip-open');
    lastTrigger = trigger || null;
    closeBtn.focus({ preventScroll: true });
  }

  function open(type, trigger) {
    var source = SOURCES[type];
    if (!source) return;

    moveOut();
    titleEl.textContent = source.title;
    bodyEl.scrollTop = 0;

    if (source.remote) {
      var holder = document.createElement('div');
      holder.className = 'mip__content mip__content--page rte';
      holder.textContent = 'Lädt …';
      bodyEl.appendChild(holder);
      show(trigger);
      loadRemote(source)
        .then(function (html) { holder.innerHTML = html; })
        .catch(function () { window.location.href = source.url; });
      return;
    }

    var section = source.find();
    if (!section) return;
    moveIn(section);
    show(trigger);
  }

  function close() {
    if (!isOpen()) return;
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    root.classList.remove('mip-open');
    setGlassHover(false);
    // Inhalt erst nach der Ausfahr-Animation zurueck an seinen Platz.
    returnTimer = window.setTimeout(moveOut, 450);
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  rows.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mip-open]');
    if (button) open(button.dataset.mipOpen, button);
  });

  // Links außerhalb der Zeilen (z. B. "Versand" unter dem Preis) öffnen dasselbe Seitenfenster
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[data-mip-open]') : null;
    if (!link || rows.contains(link)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open(link.dataset.mipOpen, link);
  });

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.getClientRects().length > 0; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------- Grosser Schliessen-Kreis auf dem Milchglas (nur Maus) ---------- */

  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cursor = null;

  function setGlassHover(on) {
    if (!cursor) return;
    cursor.classList.toggle('is-visible', on);
    root.classList.toggle('mip-glass-hover', on);
  }

  if (finePointer) {
    cursor = document.createElement('div');
    cursor.className = 'mcr-close mip-close-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML = '<svg viewBox="0 0 28 28" focusable="false"><path d="M7 7l14 14M21 7L7 21"/></svg>';
    document.body.appendChild(cursor);

    document.addEventListener('mousemove', function (event) {
      var on = isOpen() && event.target === overlay;
      if (on) {
        var half = cursor.offsetWidth / 2;
        cursor.style.transform = 'translate(' + (event.clientX - half) + 'px,' + (event.clientY - half) + 'px)';
      }
      setGlassHover(on);
    }, { passive: true });

    document.addEventListener('mouseleave', function () { setGlassHover(false); });
  }
})();
